import Headroom from 'headroom.js';

const $header = document.querySelector('.header');

if ($header) {
    const headroom = new Headroom($header, {
        offset: $header.offsetHeight,
        tolerance: 5,
        classes: {
            initial: 'headroom',
            pinned: 'is-pinned',
            unpinned: 'is-unpinned',
            top: 'is-top',
            notTop: 'is-not-top',
            bottom: 'is-bottom',
            notBottom: 'is-not-bottom',
            frozen: 'is-frozen',
        },
    });
    headroom.init();
}
